import React, {Component} from 'react'
import StarRatingComponent from 'react-star-rating-component'

class ListAscents extends Component {
  render() {
    let {ascents} = this.props
    let sortedAscents = Object.assign([], ascents).sort((a, b) => {
      let atime = a.timestamp || new Date('December 17, 1995 03:24:00')
      let btime = b.timestamp || new Date('December 17, 1995 03:24:00')
      return atime > btime ? -1 : 1
    })
    return (
      <div className="ascent-list">
        {sortedAscents.map((ascent, index) => {
          return (
            <div
              className="ascent"
              key={ascent.key}
              style={{padding: '15px 15px'}}>
              <h3 style={{marginTop: 5, marginBottom: 0}}>{ascent.userName}</h3>
              <div>
                {ascent.timestamp && ascent.timestamp.toDate().toString()}
              </div>
              <StarRatingComponent
                name="boulder-rating"
                editing={false}
                starCount={5}
                emptyStarColor="#aaaaaa"
                value={ascent.rating}
              />
              <div>
                {ascent.grade.vgrade}/font {ascent.grade.font}
              </div>
              <div>{ascent.notes && '"' + ascent.notes + '"'}</div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default ListAscents



// WEBPACK FOOTER //
// ./src/components/problems/ListAscents.jsx